import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles({
  link: {
    color: 'inherit',
    fontSize: 14,
  },
});
